

import { PoStatusEnum } from '@shahi-analytics/shared-models';
import { PrimaryGeneratedColumn, Entity, Column, CreateDateColumn, UpdateDateColumn, VersionColumn, Index } from 'typeorm';
import { CommonFieldsModel } from './common-fields.model';

@Entity('m_schedule_dc')
export class ScheduleDcEntity extends CommonFieldsModel {
    @PrimaryGeneratedColumn('increment',{
        name:'id'
    })
    id: number;

    @Column('int', {
        nullable: false,
        name: 'po_sch_id'
    })
    poSchId: number;

    @Column('int', {
        nullable: false,
        name: 'po_header_id'
    })
    poHeaderId: number;

    @Column('varchar', {
        nullable: false,
        length: 20,
        name: 'dc_no'
    })
    dcNo: string;

    @Column('int', {
        nullable: false,
        name: 'quantity'
    })
    quantity: number;

}


